/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Dropdown caret down icon.
 *
 * @file DropdownCaretDownIcon.jsx
 * @author Anuja Gaikwad
 * @since 2.0.0
 */

import React from 'react';
import { SvgIcon } from '@mui/material';

const DropdownCaretDownIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 10 6">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.09941 0H8.90059C9.50778 0 10 0.490743 10 1.0961C10 1.39081 9.88097 1.6731 9.66976 1.87929L5.76917 5.68708C5.34178 6.10431 4.65823 6.10431 4.23083 5.68708L0.330241 1.87929C-0.103604 1.45576 -0.110935 0.761786 0.313867 0.329247C0.520673 0.118674 0.803817 0 1.09941 0Z"
      fill="#171717"
    />
  </SvgIcon>
);

export default DropdownCaretDownIcon;

